import type { AppTokens } from '@/theme';
import { tintFor } from '@/theme/categorical';
import type { PrivacyTone } from './privacy';

/** A privacy or permission tone's wash and ink (visual contract v2 §3, §8). */
export function privacyColours(
  tone: PrivacyTone,
  tokens: AppTokens,
): { background: string; ink: string } {
  const lavender = tintFor('lavender', tokens);
  const colours: Record<PrivacyTone, { background: string; ink: string }> = {
    private: { background: tokens.successSoft, ink: tokens.successText },
    shared: { background: tokens.warningSoft, ink: tokens.warningText },
    partner: { background: lavender.soft, ink: tokens.text },
    community: { background: lavender.soft, ink: tokens.text },
  };
  return colours[tone];
}
